<script>
import api from "../../services/api";
import Loader from "../../components/loader";
import {toPlural} from "@/helpers/utils";

export default {
  props: {
    resourceName: {
      type: String,
      required: true
    },
    resource: {
      type: Object,
      required: true
    },
    title: {
      type: String
    },
    validated: {
      type: Boolean,
      default: true
    },
    format: {
      type: Function,
      default: function (resource) {
        return resource;
      }
    }
  },
  components: {
    Loader
  },
  data() {
    return {
      isSubmitting: false,
      localResourceNamePlur: toPlural(this.resourceName),
    };
  },
  computed: {},
  methods: {
    async submitForm() {
      this.isSubmitting = true;

      let payload = JSON.parse(JSON.stringify(this.resource));
      this.format(payload);

      api.save(this.localResourceNamePlur, payload).then((response) => {
        if (response.status !== 200)
          this.$emit('error');
        else
          this.$emit('submitted');

        this.isSubmitting = false;
      }).catch(() => {
        this.$emit('error');
        this.isSubmitting = false;
      });
    },
  },
  mounted() {
  }
};
</script>

<template>
  <Loader :loading="isSubmitting">
    <b-card no-body class="p-0 mb-0">
      <b-card-header>
        <slot name="title" class="card-title mb-4 text-uppercase">{{ resource.title }}</slot>
      </b-card-header>
      <b-card-body>
        <div class="container">
          <slot/>
        </div>
      </b-card-body>
      <b-card-footer>
        <b-row>
          <b-col>
            <div class="text-right">
              <slot name="footer"></slot>
              <b-button variant="primary" class="text-capitalize" :disabled="!validated" @click="submitForm">
                {{ $t('general.save') }}
              </b-button>
              <b-button variant="secondary" class="ms-2 text-capitalize" @click="$emit('cancel')">
                {{ $t('general.cancel') }}
              </b-button>
            </div>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </Loader>
</template>
